import React from "react";
import "./App.css";
import NavBar from "./components/Navbar/navBar";
import { PersonSearch } from "./pages/personSearch";
import PersonFound from "./pages/PersonFound";
import { LostPeople } from "./pages/lost";
import AddPerson from "./pages/addPerson";
import Login from "./pages/login";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { useStyles } from "./theme/them";
import ProtectedRoute from "./keycloak/ProtectedRoute";

const App = () => {
  const { classes } = useStyles();

  return (
    <>
      <HashRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <ProtectedRoute guest>
                <Login />
              </ProtectedRoute>
            }
          />
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <div className={classes.container}>
                  <NavBar />
                  <div className={classes.component}>
                    <Routes>
                      <Route path="/search" element={<PersonSearch />} />
                      <Route path="/add" element={<AddPerson />} />
                      <Route path="/found" element={<PersonFound />} />
                      <Route path="/lost" element={<LostPeople />} />
                      <Route path="*" element={<Navigate to="/search" replace />} />
                    </Routes>
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
      </HashRouter>
    </>
  );
};

export default App;
